import getCharts from '../getCharts'
import { FacilityType } from '../../constants/api.config'

export default async function FacilityTypeFn(mode, Id="",Name="",Shape="",Details="") {
  try {
    const jsonData = {Id,Name,Details,Shape}
    const payload = {mode,jsonData:JSON.stringify(jsonData)}
    const res = await getCharts(FacilityType, payload)
    return res.data
  } catch (error) {
    return error
  }
}
